module.exports = __webpack_public_path__ + "static/map-bg-12f5c345f088b283612766446a84e563.png";